<p-multiSelect
  [options]="optionsColumn"
  [(ngModel)]="dataTable.columns"
  [style]="{ 'min-width': '200px', 'margin-right': '1rem'}"
  [filter]="true"
  optionLabel="header"
  (onPanelHide)="onConfirm()"
  appendTo="body"
  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
  <ng-template let-value pTemplate="item">
    <div>
      <div>{{ value.header | translate }}</div>
    </div>
  </ng-template>
  <ng-template pTemplate="selectedItems" let-value>
    <div *ngIf="value && value.length < 4">
      <span *ngFor="let col of dataTable.columns; first as isFirst">
        <ng-container *ngIf="!isFirst">, </ng-container>
        {{ col.header | translate }}
      </span>
    </div>
    <span *ngIf="value && value.length >= 4">
      {{ value.length }} {{ 'Common.Table.Toggle' | translate }}
    </span>
    <span *ngIf="!value || value.length === 0">{{ 'Common.Message.ChooseOption' | translate }}</span>
  </ng-template>
</p-multiSelect>
